/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Point_1_TextInputs */

const en_visa_o1_point_1_text = /** @type {(inputs: Visa_O1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The strongest evidence can vary by profession, so we avoid reducing O-1 screening to a short list of titles or credentials.`)
};

const pt_visa_o1_point_1_text = /** @type {(inputs: Visa_O1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A evidência mais forte pode variar por profissão, então evitamos reduzir a triagem O-1 a uma lista curta de cargos ou credenciais.`)
};

const es_visa_o1_point_1_text = /** @type {(inputs: Visa_O1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La evidencia más sólida puede variar según la profesión, por lo que evitamos reducir la evaluación O-1 a una lista corta de cargos o credenciales.`)
};

/**
* | output |
* | --- |
* | "The strongest evidence can vary by profession, so we avoid reducing O-1 screening to a short list of titles or credentials." |
*
* @param {Visa_O1_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_point_1_text = /** @type {((inputs?: Visa_O1_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_point_1_text(inputs)
	if (locale === "es") return es_visa_o1_point_1_text(inputs)
	return en_visa_o1_point_1_text(inputs)
});